import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import MainPage from "./pages/Main";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import RefundAndReturnPolicy from "./pages/RefundAndReturnPolicy";
import TermsAndConditions from "./pages/TermsAndConditions";
import CompanyDetails from "./pages/CompanyDetails";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/termsandconditions" element={<TermsAndConditions />} />
        <Route path="/privacypolicy" element={<PrivacyPolicy />} />
        <Route
          path="/refundandreturnpolicy"
          element={<RefundAndReturnPolicy />}
        />
        <Route path="/companydetails" element={<CompanyDetails />} />
      </Routes>
    </Router>
  );
}

export default App;
